import React from "react";
import { Skeleton } from "antd";

import styled from "styled-components/macro";

const CardsSkeleton = styled.section`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-gap: 24px;
  width: 100%;
`;

const SkeletonCard = styled.article`
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  border: none;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.15);
  transition: 0.3s ease;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 25px;
  padding: 16px;
  width: 100%;
  .ant-skeleton-paragraph {
    margin-top: 7.5px !important;
    padding-left: 0px;
  }
`;

const SkeletonTeamList = () => {
  return (
    <CardsSkeleton>
      <SkeletonCard>
        <Skeleton
          active
          avatar={false}
          title={{ width: 120, rows: 1 }}
          paragraph={{ rows: 1, width: 100 }}
        />
      </SkeletonCard>
      <SkeletonCard>
        <Skeleton
          active
          avatar={false}
          title={{ width: 120, rows: 1 }}
          paragraph={{ rows: 1, width: 100 }}
        />
      </SkeletonCard>
      <SkeletonCard>
        <Skeleton
          active
          avatar={false}
          title={{ width: 120, rows: 1 }}
          paragraph={{ rows: 1, width: 100 }}
        />
      </SkeletonCard>
    </CardsSkeleton>
  );
};

export default SkeletonTeamList;
